export const ROUTE_SEARCH = '/';
export const ROUTE_VIS = '/vis';
export const ROUTE_SHARE = '/share';
export const ROUTE_VIEWER = '/viewer';
